/**
 * 管理端  客户管理
 */
 <template>
    <div class="login-page">
      <topInfo></topInfo>
      <sysNav></sysNav>
      <!-- 主体内容 -->
      <div class="eval-content" style="margin-bottom: 40px;">
         <div class="eval-con-top" style="font-size: 14px;">
            <div class="eval-con-title"><span style="font-weight: 700;">丨</span>
               <el-select v-model="currentLabel" placeholder="请选择" style="width: 140px;" @change="labelChange()">
                  <el-option
                     v-for="item in labelData"
                     :key="item.key"
                     :label="item.label"
                     :value="item.key">
                  </el-option>
               </el-select>
            </div>
            <div style="display: flex;justify-content: flex-end;margin-left: auto;">
               <div v-if="currentLabel=='customer'&&editCustomerBtnAuth" class="eval-con-btn" @click="showEditCustomer()">新增用户</div>
               <div v-if="currentLabel=='customer'&&importCustomerBtnAuth" class="eval-con-btn" @click="showImportCustomer()">导入用户</div>
               <!-- <div v-if="currentLabel=='agent'&&editAgentBtnAuth" class="eval-con-btn" @click="showEditAgent()">新增专家</div> -->
               <div v-if="currentLabel=='admin'&&editAdminBtnAuth" class="eval-con-btn" @click="showEditAdmin()">新增管理员</div>
               <div class="eval-con-search">
                  <el-input v-model="formInline.keyword" placeholder="请输入关键词" clearable>
                     <el-button slot="append" @click="checkSearch()">搜索</el-button>
                  </el-input>
               </div>
            </div>
         </div>
         <div v-if="currentLabel == 'customer'" class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="customerData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span style="color: #407AA8;cursor: pointer;" title="编辑用户信息" @click="showEditCustomer(scope.$index, scope.row)">{{ scope.row.name }}</span>
                  </template>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="账户(手机号)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="company" align="center" label="单位" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="department" align="center" label="部门" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column prop="role_name" align="center" label="角色" show-overflow-tooltip>
               </el-table-column> -->
               <el-table-column prop="points" align="center" label="积分" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span style="color: #407AA8;cursor: pointer;" title="查看积分记录" @click="showCusPointsLog(scope.row)">{{ scope.row.points }}</span>
                  </template>
               </el-table-column>
               <!-- <el-table-column prop="add_time" align="center" label="提交时间" show-overflow-tooltip>
               </el-table-column> -->
               <el-table-column align="center" label="操作" min-width="120">
                  <template slot-scope="scope">
                     <el-button size="mini" style="background-color: #2A91DD;" type="primary" :disabled="!pointsRechargeBtnAuth" @click="handleRechargePoints(scope.row)">积分充值</el-button>
                     <el-button size="mini" type="warning" @click="resetCusPsd(scope.row)">重置密码</el-button>
                  </template>
               </el-table-column>
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
         <!-- 用户编辑界面 -->
         <div class="edit-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editCustomerVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
               <el-form :model="customerForm" style="margin-top: 30px;" ref="customerForm" :rules="customerFormRules">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="name"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>姓名</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.name" placeholder="请填写姓名" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="mobile"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>账户(手机号)</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.mobile" placeholder="请填写手机号" clearable></el-input>
                  </div>
                  <!-- <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="role_id"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>角色</div>
                     <el-select v-model="customerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable @change="listenRole()">
                        <el-option
                           v-for="item in roleData"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                  </div> -->
                  <!-- <div v-if="customerForm.role_id ==2 || customerForm.role_id ==3" style="margin-top: 10px;">
                     <div style="text-align: left;" prop="pid">上级账户</div>
                     <el-select v-model="customerForm.pid" placeholder="请选择上级账户" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in pCustomerData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div> -->
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">单位</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.company" placeholder="请填写单位" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">部门</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.department" placeholder="请填写部门" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">邮箱</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="customerForm.email" placeholder="请填写邮箱" clearable></el-input>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;" type="primary" @click="commitCustomer()">确认添加</el-button>
               </el-form>
            </el-dialog>
         </div>
         <!-- 导入用户界面 -->
         <div class="import-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="importCustomerVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
               <el-form :model="importCustomerForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="role_id">角色</div>
                     <el-select v-model="importCustomerForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable @change="listenImportRole()">
                        <el-option
                           v-for="item in roleData"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                  </div>
                  <div v-if="importCustomerForm.role_id ==2 || importCustomerForm.role_id ==3" style="margin-top: 10px;">
                     <div style="text-align: left;" prop="pid">上级账户</div>
                     <el-select v-model="importCustomerForm.pid" placeholder="请选择上级账户" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in pCustomerData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">上传Excel表格</div>
                     <el-upload
                        class="upload-demo"
                        :action=importCustomerAction
                        :headers=setHeader
                        :before-upload="beforeImportCustomer"
                        :before-remove="beforeImportCusRemove"
                        :on-remove="handleImportCusRemove"
                        :on-success="handleImportCusSuccess"
                        style="text-align: left;margin-top: 10px;">
                        <el-button size="small" type="primary">选择文件</el-button>
                        <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
                     </el-upload>
                     <div v-if="importCustomerForm.customerData.length > 0" style="font-size: 12px;text-align: left;margin-top: 4px;">
                        <div>已成功读取 <span style="color: #F56C6C;">{{ importCustomerForm.customerData.length }}</span> 条数据,如确认无误,请点击确认导入</div>
                     </div>
                     <div style="font-size: 12px;text-align: left;margin-top: 6px;">
                        注：请<span style="color: #409EFF;cursor: pointer;" title="点击下载模板" @click="downloadImportCusTemp()">下载模版</span>填充数据上传,密码不填写默认为手机号
                     </div>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitImport()">确认导入</el-button>
               </el-form>
            </el-dialog>
         </div>
         <!-- 管理员列表 -->
         <div v-if="currentLabel == 'admin'" class="eval-table" style="padding-bottom: 10px;">
            <el-table size="small" :data="adminData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
               <el-table-column align="center" type="selection" width="40" fixed="left">
               </el-table-column>
               <el-table-column align="center" type="index" label="序号" width="60">
               </el-table-column>
               <el-table-column prop="name" align="center" label="姓名" show-overflow-tooltip>
                  <template slot-scope="scope">
                     <span style="color: #407AA8;cursor: pointer;" title="编辑管理员信息" @click="showEditAdmin(scope.$index, scope.row)">{{ scope.row.name }}</span>
                  </template>
               </el-table-column>
               <el-table-column prop="mobile" align="center" label="账户(手机号)" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="role_name" align="center" label="角色" show-overflow-tooltip>
               </el-table-column>
               <el-table-column prop="email" align="center" label="邮箱" show-overflow-tooltip>
               </el-table-column>
               <!-- <el-table-column prop="add_time" align="center" label="提交时间" show-overflow-tooltip>
               </el-table-column> -->
               <!-- <el-table-column align="center" label="操作" min-width="60">
                  <template slot-scope="scope">
                     <el-button size="mini" type="warning" plain>重置密码</el-button>
                  </template>
               </el-table-column> -->
            </el-table>
            <!-- 分页组件 -->
            <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
         </div>
         <!-- 管理员编辑界面 -->
         <div class="edit-customer">
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="editAdminVisible" width="400px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">{{ title }}</div>
               <el-form :model="adminForm" style="margin-top: 30px;">
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="name"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>姓名</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="adminForm.name" placeholder="请填写姓名" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="mobile"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>账户(手机号)</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="adminForm.mobile" placeholder="请填写手机号" clearable></el-input>
                  </div>
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;" prop="role_id"><span style="color: #F56C6C;padding-right: 2px;margin-left: -6px;">*</span>角色</div>
                     <el-select v-model="adminForm.role_id" placeholder="请选择角色" style="width: 100%;margin-top: 4px;" filterable clearable @change="listenRole()">
                        <el-option
                           v-for="item in sysRoleData"
                           :key="item.role_id"
                           :label="item.role_name"
                           :value="item.role_id"></el-option>
                     </el-select>
                  </div>
         
                  <!-- <div style="margin-top: 10px;">
                     <div style="text-align: left;">领域</div>
                     <el-select v-model="agentForm.area" placeholder="请选择领域" style="width: 100%;margin-top: 4px;" filterable clearable>
                        <el-option
                           v-for="item in areaData"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id"></el-option>
                     </el-select>
                  </div> -->
                  <div style="margin-top: 10px;">
                     <div style="text-align: left;">邮箱</div>
                     <el-input size="small" auto-complete="off" class="invocie-input" v-model.trim="adminForm.email" placeholder="请填写邮箱" clearable></el-input>
                  </div>
                  <el-button style="width: 100%;margin-top: 20px;background-color: #2A91DD;" type="primary" @click="commitAdmin()">确认添加</el-button>
               </el-form>
            </el-dialog>
         </div>

         <!-- 积分充值界面 -->
          <div>
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="rechargePointsVisible" width="560px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">积分充值</div>
               <div>
                  <div style="display: flex;font-size: 16px;">
                     <div style="width: 10px;height: 24px;background-color: #2A91DD;border-radius: 4px;margin-right: 12px;"></div>
                     <div style="color: #333;">充值数量</div>
                  </div>
                  <div style="width: 480px;padding: 24px 20px;background-color: #fff;box-shadow: 0 5px 10px #cec7e0a8;border-radius: 10px;margin-top: 20px;">
                     <div style="display: flex;">
                        <el-input placeholder="请输入充值数量" v-model="rechargePointsForm.points" clearable></el-input>
                     </div>
                     <div style="text-align: left;color: #999999;margin-top: 4px;">注：1积分等于1元人民币,建议每次充值为100的倍数</div>
                     <div style="text-align: left;color: #999999;margin-top: 4px;">注：充值前认真核对信息是否正确</div>
                  </div>
                  <div style="margin-top: 20px;display: flex;">
                     <el-button style="margin-left: auto;margin-right: 0px;background-color: #2A91DD;" type="primary" @click="commitRecharge()">立即充值</el-button>
                  </div>
               </div>
            </el-dialog>
          </div>

         <!-- 积分日志 -->
         <div>
            <el-dialog v-dialogDrag :close-on-click-modal="false" :visible.sync="showPointsLogVisible" width="760px">
               <div style="font-size: 16px;font-weight: 700;margin-top: -20px;">积分记录</div>
               <el-table size="small" :data="pointsLogData" highlight-current-row v-loading="loadPointsLog" border element-loading-text="拼命加载中" style="width: 100%;margin-top: 20px;" height="400px">
                  <el-table-column align="center" type="index" label="序号" width="60">
                  </el-table-column>
                  <el-table-column prop="type" align="center" label="类型" show-overflow-tooltip>
                     <template slot-scope="scope">
                        <span v-if="scope.row.type == 1">积分充值</span>
                        <span v-if="scope.row.type == 2">申请预评估</span>
                        <span v-if="scope.row.type == 3">积分分配</span>
                     </template>
                  </el-table-column>
                  <el-table-column prop="desc" align="center" label="积分操作" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="content" align="center" label="备注" show-overflow-tooltip>
                  </el-table-column>
                  <el-table-column prop="add_time" align="center" label="时间" show-overflow-tooltip>
                  </el-table-column>
               </el-table>
            </el-dialog>
         </div>
      </div>
    </div>
 </template>
 <script>
   import { 
      getCustomerPageList,
      editCustomer,
      importCustomer,
      getCusRole,
      getSelectCustomer,
      webUrl,
      getSysRole,
      getAdminPageList,
      editAdmin,
      editAgent,
      getAgentPageList,
      rechargePointsToCus,
      getImportCusExcelTemp,
      resetUserAccountPsd,
      getAdminCusPointsLog,
      getUserPageList,
      adminEditUser
   } from '../../api/evalMG'
   import md5 from 'js-md5'
   import Pagination from '../../components/Pagination'
   import topInfo from '../../components/topInfo'
   import sysNav from '../../components/sysNav'
   import { checkLogin } from '../../utils/util'
   export default {
      data() {
         return {
            // 按钮权限开始
            editCustomerBtnAuth: false,
            importCustomerBtnAuth: false,
            pointsRechargeBtnAuth: false,
            editAgentBtnAuth: false,
            editAdminBtnAuth: false,
            // 按钮权限结束
            loading: false,
            editCustomerVisible: false,
            editAgentVisible: false,
            editAdminVisible: false,
            importCustomerVisible: false,
            rechargePointsVisible: false,
            editAgentStatusVisible: false,
            showPointsLogVisible: false,
            customerData: [],
            adminData: [],
            agentData: [],
            currentLabel: 'customer',
            formInline: {
               page: 1,
               ps: 10,
               keyword: '',
               role_id: ''
            },
            rechargePointsForm: {
               cus_id: '',
               points: ''
            },
            loadPointsLog: false,
            pointsLogData: [],
            customerForm: {
               id: '',
               name: '',
               mobile: '',
               company: '',
               department: '',
               role_id: '',
               email: '',
               pid: ''
            },
            areaData:[
               {
                  id: '机械',
                  name: '机械'
               },
               {
                  id: '电学',
                  name: '电学'
               },
               {
                  id: '通信',
                  name: '通信'
               },
               {
                  id: '生物',
                  name: '生物'
               },
               {
                  id: '光电',
                  name: '光电'
               },
               {
                  id: '化学',
                  name: '化学'
               },
               {
                  id: '材料',
                  name: '材料'
               }
            ],
            agentForm: {
               id: '',
               name: '',
               mobile: '',
               email: '',
               agency_id: '',
               agency_name: '',
               position: '',
               area: '',
               status: ''
            },
            adminForm: {
               id: '',
               name: '',
               mobile: '',
               role_id: '',
               email: ''
            },
            labelData:[
               {
                  key: 'customer',
                  label: '用户列表'
               },
               {
                  key: 'admin',
                  label: '管理员列表'
               }
            ],
            importCustomerForm: {
               role_id: '',
               pid: '',
               customerData: []
            },
            title: '',
            // 用户角色
            roleData: [],
            // 管理员角色
            sysRoleData: [],
            // 上级账户
            pCustomerData: [],
            setHeader:{
               'token': localStorage.getItem('userToken')
            },
            // 用户数据导入地址
            importCustomerAction:webUrl + '/admin/admin/uploadCustomerExcel',
            // 用户导入excel模版
            importCusExcelTemp: '',
            customerFormRules: {
               name: [
                  { required: true, message: '请填写姓名', trigger: 'blur' }
               ],
               mobile: [
                  { required: true, message: '请填写手机号', trigger: 'blur' }
               ],
               role_id: [
                  { required: true, message: '请选择角色', trigger: 'blur' }
               ],
            },
            // 分页参数
            pageparm: {
               currentPage: 1,
               pageSize: 10,
               total: 10
            }
         }
      },
      // 注册组件
      components: {
         Pagination,
         topInfo,
         sysNav
      },
      created(){
         // 获取账户权限按钮
         let btnAuth = JSON.parse(localStorage.getItem('btnAuth'))
         if(btnAuth.includes("editCustomerBtn")){
            this.editCustomerBtnAuth = true
         }
         if(btnAuth.includes("importCustomerBtn")){
            this.importCustomerBtnAuth = true
         }
         if(btnAuth.includes("editAgentBtn")){
            this.editAgentBtnAuth = true
         }
         if(btnAuth.includes("editAdminBtn")){
            this.editAdminBtnAuth = true
         }
         if(btnAuth.includes("pointsRechargeBtn")){
            this.pointsRechargeBtnAuth = true
         }
         this.getCustomerData()
         // this.getCusRoleData()
         this.getSysRoleData()
      },
      methods: {
         checkType(val){
            this.applyForm.type = val
         },
         checkArea(val){
            this.applyForm.area = val
         },
         // 跳转客户管理
         jumpCustomer(){
            this.$router.push({ path: '/system/customer'});
         },
         // 跳转账户管理
         jumpAccount(){
            this.$router.push({ path: '/system/account'});
         },
         // 跳转案件管理
         jumpCase(){
            this.$router.push({ path: '/system/case'});
         },
         // 跳转个人中心
         jumpPersonCenter(){
            this.$router.push({ path: '/system/personCenter'});
         },
         // 查询客户列表
         getCustomerData(){
            this.loading = true
            getUserPageList(this.formInline)
            .then(res=>{
               res = checkLogin(res);
                if(!res){
                 this.$message({
                   type: 'warning',
                   message: '登录已失效,请重新登录!'
                 }) 
                  // 登陆已失效 清除登陆状态
                  setTimeout(() => {
                     window.localStorage.removeItem('userToken');
                     window.localStorage.removeItem('sign');
                     window.localStorage.removeItem('userData');
                     this.$router.push({ path: '/login'});
                     }, 1000)
                }
               if(res.code == 200){
                  this.customerData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 显示新增用户界面
         showEditCustomer(index,row){
            if(!this.editCustomerBtnAuth){
               this.$message({
                  type: 'warning',
                  message: '暂无操作权限!'
               })
               return false
            }
            if(row){
               this.title = '编辑用户'
               this.customerForm.id = row.id
               this.customerForm.name = row.name
               this.customerForm.mobile = row.mobile
               this.customerForm.password = row.password
               // this.customerForm.role_id = row.role_id
               // this.customerForm.pid = row.pid
               this.customerForm.company = row.company
               this.customerForm.department = row.department
               this.customerForm.email = row.email
               // if(row.role_id == 2){
               // this.getPCustomerData(1)
               // }
               // if(row.role_id == 3){
               //    this.getPCustomerData(2)
               // }
            }else{
               this.title = '新增用户'
               this.customerForm.id = ''
               this.customerForm.name = ''
               this.customerForm.mobile = ''
               this.customerForm.password = ''
               // this.customerForm.role_id = ''
               // this.customerForm.pid = ''
               this.customerForm.company = ''
               this.customerForm.department = ''
               this.customerForm.email = ''
            }           
            this.editCustomerVisible = true
         },
         // 显示新增专家界面
         showEditAgent(index,row){
            if(!this.editAgentBtnAuth){
               this.$message({
                  type: 'warning',
                  message: '暂无操作权限!'
               })
               return false
            }
            if(row){
               this.title = '编辑专家'
               this.agentForm.id = row.id
               this.agentForm.name = row.name
               this.agentForm.mobile = row.mobile
               this.agentForm.area = row.area
               this.agentForm.email = row.email
               this.agentForm.agency_name = row.agency_name
               this.agentForm.position = row.position
               this.agentForm.status = row.status
            }else{
               this.title = '新增专家'
               this.agentForm.id = ''
               this.agentForm.name = ''
               this.agentForm.mobile = ''
               this.agentForm.area = ''
               this.agentForm.email = ''
               this.agentForm.agency_name = ''
               this.agentForm.position = ''
               this.agentForm.status = 2
            }           
            this.editAgentVisible = true
         },
         // 显示专家状态审核
         showEditAgentStatus(row){
            this.title = '编辑专家状态'
            this.agentForm.id = row.id
            this.agentForm.name = row.name
            this.agentForm.mobile = row.mobile
            this.agentForm.area = row.area
            this.agentForm.email = row.email
            this.agentForm.agency_name = row.agency_name
            this.agentForm.position = row.position
            this.agentForm.status = row.status
           this.editAgentStatusVisible = true
         },
         // 显示新增管理员界面
         showEditAdmin(index,row){
            if(!this.editAdminBtnAuth){
               this.$message({
                  type: 'warning',
                  message: '暂无操作权限!'
               })
               return false
            }
            if(row){
               this.title = '编辑管理员'
               this.adminForm.id = row.id
               this.adminForm.name = row.name
               this.adminForm.mobile = row.mobile
               this.adminForm.role_id = row.role_id
               this.adminForm.email = row.email
            }else{
               this.title = '新增管理员'
               this.adminForm.id = ''
               this.adminForm.name = ''
               this.adminForm.mobile = ''
               this.adminForm.role_id = ''
               this.adminForm.email = ''
            }           
            this.editAdminVisible = true
         },
         // 查询用户角色数据
         getCusRoleData(){
            let param = {}
            getCusRole(param)
            .then(res=>{
               if(res.code == 200){
                  this.roleData = res.data
               }
            })
         },
         // 查询管理员角色数据
         getSysRoleData(){
            let param = {}
            getSysRole(param)
            .then(res=>{
               if(res.code == 200){
                  this.sysRoleData = res.data
               }
            })
         },
         // 提交新增用户
         commitCustomer(){
            let data = this.customerForm
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写姓名'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写手机号'
               })
               return false
            }
            // if(data.role_id.length <= 0){
            //    this.$message({
            //       type: 'warning',
            //       message: '请选择角色'
            //    })
            //    return false
            // }
            let param = {
               name: data.name,
               mobile: data.mobile,
               // role_id: data.role_id,
               company: data.company,
               department: data.department,
               email: data.email,
               // pid: data.pid,
               id: data.id
            }
            adminEditUser(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editCustomerVisible = false
                  this.getCustomerData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         }, 
         // 提交新增专家
         commitAgent(){
            let data = this.agentForm
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写姓名'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写手机号'
               })
               return false
            }
            if(data.area.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择领域'
               })
               return false
            }
            if(data.position.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择职位'
               })
               return false
            }
            let param = {
               id: data.id,
               name: data.name,
               mobile: data.mobile,
               area: data.area,
               email: data.email,
               agency_id: data.agency_id,
               agency_name: data.agency_name,
               position: data.position,
               status: data.status
            }
            editAgent(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAgentVisible = false
                  this.getAgentData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 提交专家状态
         commitAgentStatus(){
            let data = this.agentForm
            let param = {
               id: data.id,
               name: data.name,
               mobile: data.mobile,
               area: data.area,
               email: data.email,
               agency_id: data.agency_id,
               agency_name: data.agency_name,
               position: data.position,
               status: data.status
            }
            editAgent(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAgentStatusVisible = false
                  this.getAgentData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 提交编辑管理员
         commitAdmin(){
            let data = this.adminForm
            if(data.name.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写姓名'
               })
               return false
            }
            if(data.mobile.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写手机号'
               })
               return false
            }
            if(data.role_id.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择角色'
               })
               return false
            }
            let param = {
               id: data.id,
               name: data.name,
               mobile: data.mobile,
               role_id: data.role_id,
               email: data.email
            }
            editAdmin(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.editAdminVisible = false
                  this.getAdminData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         
         },
         // 点击搜索
         checkSearch(){
            this.formInline.page = 1
            let label = this.currentLabel
            if(label == 'customer'){
               this.getCustomerData()
            }
            if(label == 'agent'){
               this.getAgentData()
            }
            if(label == 'admin'){
               this.getAdminData()
            }

            
         },
         // 角色值发生变化
         listenRole(){
            let role_id = this.customerForm.role_id
            if(role_id == 2){
               this.getPCustomerData(1)
            }
            if(role_id == 3){
               this.getPCustomerData(2)
            }
         },
          // 角色值发生变化
          listenImportRole(){
            let role_id = this.importCustomerForm.role_id
            if(role_id == 2){
               this.getPCustomerData(1)
            }
            if(role_id == 3){
               this.getPCustomerData(2)
            }
         },
         // 查询上级用户数据
         getPCustomerData(type){
            let param = { type }
            getSelectCustomer(param)
            .then(res=>{
               if(res.code == 200){
                  this.pCustomerData = res.data
               }
            })
         },
         // 显示导入用户界面
         showImportCustomer(){
            // 查询导入文件模板
            getImportCusExcelTemp({})
            .then(res=>{
               if(res.code == 200){
                  this.importCusExcelTemp = res.data.url
                  this.title = '导入用户'
                  this.importCustomerForm.pid = ''
                  this.importCustomerForm.role_id = ''
                  this.importCustomerForm.customerData = []
                  this.importCustomerVisible = true
               }
            })
         },
         // 下载用户导入模板
         downloadImportCusTemp(){
            let url = this.importCusExcelTemp
            window.location.href = url
         },
         // 确认导入
         commitImport(){
            let data = this.importCustomerForm
            if(data.role_id.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择角色'
               })
               return false
            }
            if(data.role_id != 1 && data.pid.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请选择账户上级'
               })
               return false
            }
            if(data.customerData.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请上传用户数据表格'
               })
               return false
            }
            let param = {
               pid: data.pid,
               role_id: data.role_id,
               customerData: JSON.stringify(data.customerData)
            }
            importCustomer(param)
            .then(res=>{
               if(res.code == 200){
                  this.$message({
                     type: 'success',
                     message: res.msg
                  })
                  this.importCustomerVisible = false
                  this.getCustomerData()
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 用户导出
         exportCustomer(){
            
         },
         // 查看用户积分记录
         showCusPointsLog(val){
            let cus_id = val.id
            let param = {
               cus_id: cus_id
            }
            getAdminCusPointsLog(param)
            .then(res=>{
               if(res.code == 200){
                  this.pointsLogData = res.data
                  this.showPointsLogVisible = true
               }else{
                  this.$message({
                     type: 'error',
                     message: res.msg
                  })
               }
            })
         },
         // 重置用户账户密码
         resetCusPsd(row){
            let param = {
               cus_id: row.id,
               mobile: row.mobile
            }
            this.$confirm('确定要重置此账户密码?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               resetUserAccountPsd(param)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },
         // 分页插件事件
         callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.ps = parm.pageSize
            let label = this.currentLabel
            if(label == 'customer'){
               this.getCustomerData()
            }
            if(label == 'agent'){
               this.getAgentData()
            }
            if(label == 'admin'){
               this.getAdminData()
            }
         },

         // 文件上传开始
         // 删除文件之前的钩子
         beforeImportCusRemove(file, fileList) {
            return this.$confirm(`确定移除 ${file.name}？`);
         },
         // 文件列表移除文件时的钩子
         handleImportCusRemove(file, fileList) {},
         // 文件上传成功时的钩子
         handleImportCusSuccess(response, file, fileList) {
            if(response.code == 200){
               this.$message({
                  type: 'success',
                  message: '导入成功!'
               })
               this.importCustomerForm.customerData = response.data
            }else{
               this.$message({
                  type: 'error',
                  message: response.msg
               })
            }
         },
         //文件上传前的校验
         beforeImportCustomer(file) {
            const that = this
            if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
               that.$message({
                  type: 'error',
                  message: '上传文件只能为excel文件，且为xlsx,xls格式!'
               })
               return false
            }
         }, 

         // 文件上传结束

         // 查询专家列表
         getAgentData(){
            this.loading = true
            getAgentPageList(this.formInline)
            .then(res=>{
               if(res.code == 200){
                  this.agentData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 管理员

         // label值切换
         labelChange(){
            this.formInline.page = 1
            this.formInline.keyword = ''
            this.formInline.role_id = ''
            let label = this.currentLabel
            if(label == 'customer'){
               this.getCustomerData()
            }
            if(label == 'agent'){
               this.getAgentData()
            }
            if(label == 'admin'){
               this.getAdminData()
            }

         },

         // 查询管理员列表
          // 查询客户列表
          getAdminData(){
            this.loading = true
            getAdminPageList(this.formInline)
            .then(res=>{
               if(res.code == 200){
                  this.adminData = res.data.dataList
                  this.pageparm.currentPage = this.formInline.page
                  this.pageparm.pageSize = this.formInline.ps
                  this.pageparm.total = res.data.total
                  this.loading = false
               }else{
                  this.$message({
                     type: 'warning',
                     message: res.msg
                  })
                  this.loading = false
               }
            })
         },
         // 显示积分充值弹窗
         handleRechargePoints(val){
            this.rechargePointsForm.cus_id = val.id
            this.rechargePointsForm.points = ''
            this.rechargePointsVisible = true
         },
         // 提交积分充值
         commitRecharge(){
            let data = this.rechargePointsForm
            if(!data.points || data.points.length <= 0){
               this.$message({
                  type: 'warning',
                  message: '请填写充值数量!'
               })
               return false
            }
            if(!/^\d*$/.test(data.points)){
               this.$message({
                  type: 'warning',
                  message: '请填写正确的充值数量!'
               })
               return false
            }
             // 确认按钮
             this.$confirm('确定给此账户充值积分?', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
            })
            .then(()=>{
               rechargePointsToCus(data)
               .then(res=>{
                  if(res.code == 200){
                     this.$message({
                        type: 'success',
                        message: res.msg
                     })
                     this.getCustomerData()
                     this.rechargePointsVisible = false
                  }else{
                     this.$message({
                        type: 'error',
                        message: res.msg
                     })
                  }
               })
            })
            .catch(() => {
               this.$message({
                  type: 'info',
                  message: '已取消'
               })
            })
         },

      }
   }
</script>
<style scoped>
  .login-page {
    text-align: center;
    /* height: 100%; */
  }
  .login-title {
    font-size: 44px;
    font-weight: 700;
    padding-top: 24px;
  }
  .login-title-en {
    font-size: 16px;
    color: #5a5a5a;
    margin-top: 10px;
  }
  .eval-content {
   width: 1200px;
   /* height: 600px; */
   margin: 0px auto;
   background-color: #fff;
   border-radius: 10px;
  }
  .eval-con-top {
   display: flex;
   margin: 10px 40px;
   padding: 16px 0px;
   /* border-bottom: 2px solid #eeeeee; */
  }
  .eval-con-title {
   color: #2A91DD;
   height: 36px;
   line-height: 36px;
   font-size: 16px;
   font-weight: 700;
  }
  .eval-con-btn {
   width: 100px;
   height: 36px;
   line-height: 36px;
   text-align: center;
   color: #fff;
   background-color: #2A91DD;
   border-radius: 5px;
   margin-left: 20px;
   cursor: pointer;
  }
  .eval-con-search {
   margin-left: 20px;
  }
  .eval-con-search>>>.el-input-group {
   border-radius: 10px !important;
  }
  .eval-con-search>>>.el-input-group__append, .el-input-group__prepend {
   color: #FFFFFF;
   background-color: #2A91DD;
   cursor: pointer;
  }
  .eval-con-search>>>.el-input__inner {
   background-color: #F3F3F3 !important;
   border: none;
  }
  .eval-table {
   width: 1120px;
   margin: 0px auto;
  }
  .eval-table>>> .el-table__header th {
   background-color: #2A91DD !important;
  }
  .eval-table>>> .el-table thead {
   color: #FFFFFF;
  }
.invocie-input{
   background-color: #ECEDF4;
   margin-top: 4px;
  }
.import-customer>>>.el-input--suffix .el-input__inner {
   height: 32px !important;
}
.import-customer>>>.el-input__icon{
   height: 32px !important;
   line-height: 32px !important;
}
.edit-customer>>>.el-input--suffix .el-input__inner {
   height: 32px !important;
}
.edit-customer>>>.el-input__icon{
   height: 32px !important;
   line-height: 32px !important;
}
.eval-con-title>>>input {
   font-weight: 700 !important;
   color: #2A91DD !important;
}
</style>


// WEBPACK FOOTER //
// src/views/system/account.vue